<template>
  <section id="feedback" class="testimonial">
    <div class="testimonial-decor">
      <div class="testi-circle1"><img :src='"../../assets/images/Testimonial2-blue.png"' alt=""></div>
      <div class="testi-circle2"><img :src='"../../assets/images/Testimonial1-blue.png"' alt=""></div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-lg-10 offset-lg-1">
          <carousel :className='"testimonial-carousel "'
                    :loop=true
                    :margin=30
                    :items=1
                    :center=true
                    :nav=true
                    :dots=false
                    :dotsEach=false
                    :autoplay=true
                    :responsive="{0:{items:1,dots:true,nav:false},768:{items:1,dots:true,nav:false},992:{nav:true}}"
          >
            <div class="testimonial-item" v-for="i in feedbacks" :key="i.id">
              <div class="testimonial-block">
                <div class="testimonial-avtar">
                  <img :src="getImgUrl(i.avatarSrc)" alt=""
                       :style="i.id === 2 ? 'object-fit: scale-down;':  'object-fit: cover; '">
                </div>
                <div class="testimonial-text">
                  <p>{{ $t(`offer.feedback.text.${i.id}.text`) }} </p>
                  <h3>{{ $t(`offer.feedback.text.${i.id}.name`) }}</h3>
                  <h6>{{ $t(`offer.feedback.text.${i.id}.position`) }}</h6>
                </div>
              </div>
            </div>
          </carousel>
        </div>
      </div>
    </div>
  </section>
</template>
<script>

export default {
  data: () => ({
    feedbacks: [
      {
        id: 1,
        avatarSrc: '1.jpg'
      },
      {
        id: 2,
        avatarSrc: '2.jpg'
      },
      {
        id: 3,
        avatarSrc: '3.jpg'
      },
      {
        id: 4,
        avatarSrc: '4.jpg'
      },
      {
        id: 5,
        avatarSrc: '5.jpg'
      },
      {
        id: 6,
        avatarSrc: 'empty.jpg'
      }
    ]
  }),
  methods: {
    getImgUrl(image) {
      return require('@/assets/images/feedbacks/' + image)
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/offerPage/feedback.vue